import { IFormattedApiError } from '../api/core/types';

export enum EAsyncActionTypes {
  ADD_ERROR = 'ADD_ERROR',
  HIDE_LOADER = 'HIDE_LOADER',
  REMOVE_ERROR = 'REMOVE_ERROR',
  SHOW_LOADER = 'SHOW_LOADER',
  SHOW_TOASTER = 'SHOW_TOASTER',
  HIDE_TOASTER = 'HIDE_TOASTER',
}

export enum EAsyncEventTypes {
  AFFINY_MATCH_LIST = 'AFFINY_MATCH_LIST',
  AFFINY_ADDITIONAL_MATCH_LIST = 'AFFINY_ADDITIONAL_MATCH_LIST',
  AFFINY_MATCH_LIST_ANNOUNCE = 'AFFINY_MATCH_LIST_ANNOUNCE',
  ANNOUNCE = 'ANNOUNCE',
  ANSWER_PHOTO_REQUEST = 'ANSWER_PHOTO_REQUEST',
  BLOCK_USER = 'BLOCK_USER',
  BOOTSTRAP_APP = 'BOOTSTRAP_APP',
  BUY_SUBSCRIPTION = 'BUY_SUBSCRIPTION',
  CANCEL_RA = 'CANCEL_AUTO_RENEWAL',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  DELETE_ACCOUNT = 'DELETE_ACCOUNT',
  DELETE_PICTURES = 'DELETE_PICTURES',
  GET_ACCOUNT_PICTURES = 'GET_ACCOUNT_PICTURES',
  GET_BLACKLIST = 'GET_BLACKLIST',
  GET_COMPATIBILITY_REPORT = 'GET_COMPATIBILITY_REPORT',
  GET_COMPATIBILITY_REPORT_LIGHT = 'GET_COMPATIBILITY_REPORT_LIGHT',
  GET_COUNTERS = 'GET_COUNTERS',
  GET_FACEBOOK_PHOTOS = 'GET_FACEBOOK_PHOTOS',
  GET_FAQ = 'GET_FAQ',
  GET_MARKETING_CODE = 'GET_MARKETING_CODE',
  GET_MEMBER_CHOICES = 'GET_MEMBER_CHOICES',
  GET_MORE_MESSAGES = 'GET_MORE_MESSAGES',
  GET_MY_PROFILE = 'GET_MY_PROFILE',
  GET_OPTINS = 'GET_OPTINS',
  GET_PERSONALITY_REPORT = 'GET_PERSONALITY_REPORT',
  GET_PERSONALITY_REPORT_VISION = 'GET_PERSONALITY_REPORT_VISION',
  GET_PHOTO_REVEALS = 'GET_PHOTO_REVEALS',
  GET_PICTURES = 'GET_PICTURES',
  GET_PRODUCTS = 'GET_PRODUCTS',
  GET_SCORE = 'GET_SCORE',
  GET_SPECIAL_OFFER = 'GET_SPECIAL_OFFER',
  GET_SPECIAL_OFFER_WITH_ACTION_CODE = 'GET_SPECIAL_OFFER_WITH_ACTION_CODE',
  GET_SUBSCRIPTION = 'GET_SUBSCRIPTION',
  GET_SUBSCRIPTION_AUTO_RENEWAL_STATUS = 'GET_SUBSCRIPTION_AUTO_RENEWAL_STATUS',
  GET_VISITS = 'GET_VISITS',
  GO_PAYMENT = 'GO_PAYMENT',
  GO_TO_RATE_CARD = 'GO_TO_RATE_CARD',
  HANDLE_PAYMENT_RECEIPT = 'HANDLE_PAYMENT_RECEIPT',
  HAS_COMPLETED_PROFILE = 'HAS_COMPLETED_PROFILE',
  INIT_THREAD = 'INIT_THREAD',
  LOGIN = 'LOGIN',
  MAPS_AUTOCOMPLETE = 'MAPS_AUTOCOMPLETE',
  MAPS_PLACE = 'MAPS_PLACE',
  MEMBER_CHOICE = 'MEMBER_CHOICE',
  NEW_MESSAGE_FROM_WEBSOCKET = 'NEW_MESSAGE_FROM_WEBSOCKET',
  PATCH_MY_ANNOUNCE = 'PATCH_MY_ANNOUNCE',
  PATCH_OPTINS = 'PATCH_OPTINS',
  PATCH_CITY_BIRTHDATE = 'PATCH_CITY_BIRTHDATE',
  PAYMENT_REDIRECTION = 'PAYMENT_REDIRECTION',
  PERSONALITY_MATCH_LIST = 'PERSONALITY_MATCH_LIST',
  PHOTO_REQUESTS = 'PHOTO_REQUESTS',
  PAYMENT_HISTORIES = 'PAYMENT_HISTORIES',
  POST_DRY_RUN = 'POST_DRY_RUN',
  POST_FAVORITES = 'POST_FAVORITES',
  POST_MESSAGE = 'POST_MESSAGE',
  POST_PHOTO_REQUEST = 'POST_PHOTO_REQUEST',
  POST_PICTURE = 'POST_PICTURE',
  POST_VISITS = 'POST_VISITS',
  POST_REPORT_USER = 'POST_REPORT_USER',
  POST_REACTIVATE_AUTO_RENEWAL = 'POST_REACTIVATE_AUTO_RENEWAL',
  RECEIVED_FAVORITES = 'RECEIVED_FAVORITES',
  REDIRECT_AUTH = 'REDIRECT_AUTH',
  REFLISTS_GET = 'GET_REFLISTS',
  REGISTER = 'REGISTER',
  REGISTER_COMPLETE = 'REGISTER_COMPLETE',
  RESTORE_SUBSCRIPTION = 'RESTORE_SUBSCRIPTION',
  SENT_FAVORITES = 'SENT_FAVORITES',
  SET_MAIN_PICTURE = 'SET_MAIN_PICTURE',
  SET_PICTURE_PRIVACY = 'SET_PICTURE_PRIVACY',
  SET_SORT_MATCH_LIST = 'SET_SORT_MATCH_LIST',
  SET_THREAD_AS_READ = 'SET_THREAD_AS_READ',
  SORT_MATCH_LIST = 'SORT_MATCH_LIST',
  THREADS_LIST = 'THREADS_LIST',
  UNBLOCK_USER = 'UNBLOCK_USER',
  VALUE_MATCH_LIST = 'VALUE_MATCH_LIST',
  VISION_MATCH_LIST = 'VISION_MATCH_LIST',
}

export interface IAsynchronousStateEntry {
  error?: IFormattedApiError;
  isLoading?: boolean;
  shouldShowToaster?: boolean;
}

export type TAsynchronousState = Partial<
  Record<EAsyncEventTypes, IAsynchronousStateEntry>
>;

export interface IAsyncStatusContainerFactoryOwnProps {
  asyncEventName: EAsyncEventTypes;
}

interface IAsyncEventAction<ActionType, ExtendedErrorType = {}> {
  type: ActionType;
  payload: {
    asyncEventName: EAsyncEventTypes;
  } & ExtendedErrorType;
}

export type TAddErrorAction = IAsyncEventAction<
  EAsyncActionTypes.ADD_ERROR,
  {
    error: IFormattedApiError;
  }
>;

export type TRemoveErrorAction = IAsyncEventAction<EAsyncActionTypes.REMOVE_ERROR>;

export type TShowLoaderAction = IAsyncEventAction<EAsyncActionTypes.SHOW_LOADER>;

export type THideLoaderAction = IAsyncEventAction<EAsyncActionTypes.HIDE_LOADER>;

export type TShowToasterAction = IAsyncEventAction<EAsyncActionTypes.SHOW_TOASTER>;

export type THideToasterAction = IAsyncEventAction<EAsyncActionTypes.HIDE_TOASTER>;
export type TAsyncActionTypes =
  | TAddErrorAction
  | TRemoveErrorAction
  | TShowLoaderAction
  | THideLoaderAction
  | TShowToasterAction
  | THideToasterAction;
